var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H48C52.4183 0 56 3.58172 56 8V48C56 52.4183 52.4183 56 48 56H8C3.58172 56 0 52.4183 0 48V8Z",
    fill: "#C2DAFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23.6667C21 23.0467 21 22.7367 21.0682 22.4824C21.2531 21.7922 21.7922 21.2531 22.4824 21.0682C22.7367 21 23.0467 21 23.6667 21H32.3333C32.9533 21 33.2633 21 33.5176 21.0682C34.2078 21.2531 34.7469 21.7922 34.9319 22.4824C35 22.7367 35 23.0467 35 23.6667C35 24.9066 35 25.5266 34.8637 26.0353C34.4938 27.4156 33.4156 28.4938 32.0353 28.8637C31.5266 29 30.9066 29 29.6667 29H26.3333C25.0934 29 24.4734 29 23.9647 28.8637C22.5844 28.4938 21.5062 27.4156 21.1363 26.0353C21 25.5266 21 24.9066 21 23.6667Z",
    stroke: "#005EEA",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34 27C34.3716 27.5839 34.5574 27.8759 34.689 28.1897C34.8062 28.4694 34.8913 28.7615 34.9425 29.0604C35 29.3959 35 29.7419 35 30.4341V32C35 34.8284 35 36.2426 34.1213 37.1213C33.2426 38 31.8284 38 29 38H27C24.1716 38 22.7574 38 21.8787 37.1213C21 36.2426 21 34.8284 21 32V30.4341C21 29.7419 21 29.3959 21.0575 29.0604C21.1087 28.7615 21.1938 28.4694 21.311 28.1897C21.4426 27.8759 21.6284 27.5839 22 27",
    stroke: "#005EEA",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 36C20.3235 36 19.9853 36 19.7022 35.922C19.0829 35.7512 18.5807 35.3162 18.3416 34.7433C18.2323 34.4815 18.1986 34.1593 18.1313 33.515L18.0669 32.8986C17.9899 32.1619 17.9515 31.7936 18.1089 31.5209C18.4607 30.9115 19.2512 31.0052 19.857 31.0052H21",
    stroke: "#005EEA",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36C35.6765 36 36.0147 36 36.2978 35.9219C36.9171 35.751 37.4193 35.3155 37.6584 34.742C37.7677 34.4799 37.8014 34.1574 37.8687 33.5124L37.9331 32.8954C37.9955 32.2975 38.1529 31.5626 37.5709 31.1773C37.3031 31 36.9164 31 36.143 31H35",
    stroke: "#005EEA",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25 30.5V29.5",
    stroke: "#005EEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 30.5V29.5",
    stroke: "#005EEA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21C31 19.3432 29.6569 18 28 18C26.3431 18 25 19.3432 25 21",
    stroke: "#005EEA",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExam);
export default __webpack_public_path__ + "static/media/exam.681fd9489602ef5e9090b57251d31153.svg";
export { ForwardRef as ReactComponent };